<script>
import { markdown } from '../util';

export let leadTitle;
export let title;
export let image;
export let text;
export let embed;
export let button;
</script>

<div class='box shadow col'>
  <div class='row'>
    <!-- svelte-ignore a11y-missing-attribute -->
    <div class="img">
      <img src={image} />
    </div>

    <div class="right">
      {@html embed}
    </div>
  </div>
  <div class="col start">
    <div class="leadTitle">{@html markdown(leadTitle)}</div>
    <div class="title">{@html markdown(title)}</div>

    {@html markdown(text)}

    <a href={button.href} target='_blank' class='button' style="margin-top: 16px">{button.text}</a>
  </div>
</div>

<style lang="scss">
@import '../util';

.box {
  background-color: white;
  padding: 32px;
  line-height: 1;
}

.img {
  width: calc(44% - 32px);
  margin-right: 32px;
  position: relative;

  @include mobile {
    display: none;
  }
}

img {
  object-fit: contain;
  object-position: center;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
}

.right {
  width: 56%;
  
  @include mobile {
    width: 100%;
  }
}

.leadTitle {
  margin-top: 16px;
  font-size: 28px;
  font-weight: 600;
}

.title {
  font-size: 54px;
  margin-bottom: 16px;
  font-weight: 800;
}
</style>